import React from 'react';
import { MenuItem } from '@material-ui/core';

import FormSelect from 'retired/FormSelect';

const LikertNumberOfOptionsSelector = (props) => (
  <FormSelect meta={{}} input={{}} {...props}>
    {[3, 5, 7].map((count) => (
      <MenuItem key={count} value={count}>
        {count}
      </MenuItem>
    ))}
  </FormSelect>
);
export default LikertNumberOfOptionsSelector;
